import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DashboardComponent} from '../dashboard/dashboard.component';
import {LoginApiService} from '../../services/api/login-api.service';
//import {UserModel} from 'src/app/models/user.model';
import {environment} from '../../../environments/environment';
import { UsersService } from 'src/app/services/users/users.service';
import { logo } from 'src/app/config/imagenes';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers:[UsersService]
})

export class LoginComponent implements OnInit {

    public error: boolean = false;
  /*   public logoUrl: string = environment.logoUrl; */
    public logoUrl: boolean=true;
    public password: string;
    public isDoLoginLoading: boolean;
    public errorMsg: string;
    public logo: string = logo;

    public userList:any = {
        selected: null,
       /*  values: [
            {label: '...', value: {id: ''}},
            {label: 'Casado, Carlos', value: {id: 0, password: '1234', name: 'Casado, Carlos'}},
            {label: 'Invitado', value: {id: 1, password: '1234', name: 'Invitado'}},
            {label: 'Admin', value: {id: 2, password: 'admin', name: 'Admin'}},
        ] */
        values:[
            {label: '...', value: {id: ''}},
            //{label: 'Casado, Carlos', value: {id: 0,  name: 'Casado, Carlos'}},
        ]
    };

    public static createNavigation(router: Router) {
        router.navigate(['login']);
    }

    constructor(private router: Router,
                private loginApi: LoginApiService,
                private userServiceLogin: UsersService,
            
                ) {
    }

    ngOnInit() {
       
        this.userServiceLogin.getAllUsers().subscribe((data:any)=>{
           // console.log("users",data);
            for (let index = 0; index < data.length; index++) {
                const element = {label:data[index].nombre,value: {id: data[index].idUser,  name: data[index].nombre}}
                this.userList['values'].push(element);
                
            }
           
        },error=>{
            console.log("error",error);
        });
        /*this.loginApi.getUsers()
            .then((userList: UserModel[]) => {
                this.userList.values = [];

                this.userList.values.push({
                    label: 'Seleccionar usuario...',
                    value: {id: null}
                });

                userList.forEach(user => {
                    this.userList.values.push({
                        label: (user.nombre || '') + ' ' + (user.apellidos || ''),
                        value: user
                    } as any);
                });
            });*/

        this.loginApi.checkCurrentSession()
            .then((exists: Boolean) => {
                if (exists) {
                    DashboardComponent.createNavigation(this.router);
                }
            });
    }

    public setUser(user) {
        this.userList.selected = user;
    }


    public doLogin(pass) {
        let myuser:any={
            "nombre":this.userList.selected.value.name,
            "password":pass.value
        };
        //console.log(myuser);
        this.userServiceLogin.loginUsers(myuser).subscribe((resp:any)=>{
            //console.log(resp);
            
            if(resp != null){
                if(resp.role != null && resp.role == "ROLE_ADMIN" ) {
                    localStorage.setItem("role","ROLE_ADMIN");
                } else {
                    localStorage.setItem("role",resp.role);
                }
                if(resp.readonly != null ) {
                    if ( (resp.readonly as string).localeCompare('1') == 0 ) {
                        localStorage.setItem("readonly","1");
                    } else {
                        localStorage.setItem("readonly","0");
                    }
                    
                }
                localStorage.setItem("documentos",JSON.stringify(resp.documentos));
                if (this.userList.selected) {
                    this.errorMsg = "";
                    this.isDoLoginLoading = true;
                    
                    
        
                        setTimeout(() => {
                            this.loginApi.doLogin(this.userList.selected.value)
                                .then((isValid: boolean) => {
                                    if (isValid) {
                                        DashboardComponent.createNavigation(this.router);
                                    } else {
                                        this.error = true;
                                    }
        
                                    this.isDoLoginLoading = false;
                                })
                                .catch((error: Response) => {
                                    this.error = true;
                                    this.isDoLoginLoading = false;
                                });
                        }, 700);
                    
                   
                }
            }else{
                console.log("Invalid pass");
                this.errorMsg = "Contraseña incorrecta!";
                this.isDoLoginLoading = false;
            }
           
        },error=>{
            console.log("error",error);
        });
        //this.userServiceLogin.loginUsers();
       let passw = pass.value;
       
    }

}
